import { defineComponent } from 'vue';
import { eventBus } from './core/signalr/eventBus';

/**
 * Primo file convertito da class component a `defineComponent`: e il modello che i 235 successivi
 * seguono. La corrispondenza e diretta - `get x()` diventa una voce di `computed`, `@Watch('x')`
 * una voce di `watch`, i metodi restano metodi.
 */
export default defineComponent({
  name: 'App',

  computed: {
    hasToLogout(): boolean {
      return this.$store.state.isAuthenticated;
    },
  },

  watch: {
    hasToLogout(value: boolean, oldValue: boolean) {
      if (oldValue && !value) {
        this.$router.push({ name: 'page-login' });
      }
    },
  },

  mounted() {
    eventBus.$on('Notification', (args: unknown) => {
      alert(args);
    });
  },
});
